module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-mobile"
  }, [_c('about-content', {
    attrs: {
      "isMobile": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d30e212"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnMobile.vue
// module id = 177
// module chunks = 1